<template>
    <div class="flex flex-col gap-2 sm:flex-row py-6 w-full shrink-0 items-center px-4 md:px-6 border-t bg-white relative z-10 justify-between">
        <span class="text-sm text-gray-500 sm:text-center dark:text-gray-400">© {{ currentYear }} <a href="https://flowbite.com/"
                class="hover:underline">{{ $t("marketing.auto.emanta_ydts0") }}</a>{{ $t("marketing.auto.all_rights_reserved") }}</span>
        <div class="flex mt-4 sm:justify-center sm:mt-0">
            <a href="https://www.instagram.com/emanta_traveltech?igsh=dHE5NzcxZHo1dGV0" class="text-gray-500 hover:text-gray-900 dark:hover:text-white ms-5">
                <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                    <path fill="currentColor" fill-rule="evenodd" d="M3 8a5 5 0 0 1 5-5h8a5 5 0 0 1 5 5v8a5 5 0 0 1-5 5H8a5 5 0 0 1-5-5V8Zm5-3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3H8Zm7.597 2.214a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2h-.01a1 1 0 0 1-1-1ZM12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm-5 3a5 5 0 1 1 10 0 5 5 0 0 1-10 0Z" clip-rule="evenodd"/>
                </svg>

                <span class="sr-only">{{ $t("marketing.auto.instagram") }}</span>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FooterSection',
    data() {
        return {
            currentYear: new Date().getFullYear(),
        }
    },
}
</script>

<style lang="scss" scoped></style>